export const TIMELINE_MODAL_TITLE = 'Steps To Complete Initial Setup';

export const TIMELINE_STEPS = [
  {
    stepNumber: '01',
    title: 'Create Organization',
    description:
      'You need to create an organization with all its basic details.',
  },
  {
    stepNumber: '02',
    title: 'Create Location',
    description: 'Add your first processing facility and its basic information',
  },
  {
    stepNumber: '03',
    title: 'Add Activity Data',
    description: 'Enter Scope 1, 2, and 3 data for your preferred years',
  },
  {
    stepNumber: '04',
    title: 'Finish Initial Setup',
    description:
      'You can now create product or continue doing organization setup',
  },
];

export const PROCEED_BUTTON_TEXT = 'Proceed';
export const BACK_BUTTON_TEXT = 'Back';
